import type { ConsumableMatrixItem } from "@product-details/containers/ConsumablesProductDetailsContainer/ConsumablesProductDetailsContainer.types";

export const getMatrixItemsByPackagingFormat = (
  matrixItems: ConsumableMatrixItem[],
  formatId: string
): ConsumableMatrixItem[] => {
  return matrixItems.filter((item) => {
    return item.packagingFormatId === formatId;
  });
};
